export const initialAbility = [
  {
    action: 'default',
    subject: 'Auth',
  },
]

export const _ = undefined
